import React from "react";
import { cls } from "@wss/cls";

const OutletPoliciesButton = () => {
  return (
    <div className={cls("btn-group", "ag-btn")}>
      <a
        href="/outlet-return-policy.html"
        className={cls(
          "btn",
          "btn-ui",
          "btn-mini",
          "flex",
          "items-center",
          "bg-[#EFEFEF]",
          "hover:bg-gray-50",
          "h-[15px]",
          "[@media(min-width:415px)]:h-auto",
        )}
      >
        Outlet Policies
      </a>
    </div>
  );
};
export default OutletPoliciesButton;
